import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => {}); }, []);

  if (customers.length === 0) return <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Aucun client inscrit pour le moment.</p>;

  return (
    <div className="space-y-3" data-testid="admin-customers">
      {customers.map((c) => (
        <div key={c.id} className="card-lux p-5 flex justify-between items-center gap-4" data-testid="admin-customer">
          <div>
            <p className="font-display text-lg">{c.name || "Client"}</p>
            <p className="text-xs" style={{ color: "var(--lo-muted)" }}>{c.email}</p>
            <p className="text-xs mt-1" style={{ color: "var(--lo-muted)" }}>Inscrit le {c.created_at ? new Date(c.created_at).toLocaleDateString("fr-FR") : "—"}</p>
          </div>
          <div className="text-right shrink-0">
            <p className="font-display text-xl" style={{ color: "var(--lo-rose-hi)" }}>{(c.total_spent || 0).toFixed(2).replace(".", ",")} €</p>
            <p className="overline" style={{ fontSize: "0.55rem", color: "var(--lo-muted)" }}>{c.paid_orders} cmd payée(s) · {c.orders} au total</p>
          </div>
        </div>
      ))}
    </div>
  );
}
